"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_jss_1 = require("react-jss");
var styles = (0, react_jss_1.createUseStyles)(function (theme) { return ({
    labelContainer: {
        fontFamily: ["\"".concat(theme.typography.body.regular.fontFamily, "\""), theme.typography.fallback.fontFamily],
        color: theme.color.highlight
    }
}); });
exports.default = styles;
//# sourceMappingURL=Label.styles.js.map